import _ from "lodash";
import draftToHtml from "draftjs-to-html";
import { fetchApi } from "../../utils";
import { formatDateRange } from "../../utils/formatDate";

const mapField = item => {
  return {
    ...item,
    id: _.get(item, "id"),
    image: _.get(item, "image.full_file_path"),
    description: _.reduce(
      _.get(item, "description"),
      (result, value, language) => {
        return {
          ...result,
          [language]: draftToHtml(value)
        };
      },
      {}
    ),
    title: _.get(item, 'title'),
    date: formatDateRange(_.get(item, 'promotion_start_time'), _.get(item, 'promotion_end_time')),
  };
};

const fetchPromotionApi = () => {
  return fetchApi("promotions")
    .then(res => _.get(res, "data"))
    // .then(mapField);
    .then(items => _.map(items, mapField))
};

export { fetchPromotionApi };






// WEBPACK FOOTER //
// ./src/services/page/promotion.js